import { NetworkIcon } from 'elements/NetworkIcon';
import { NETWORK_IDS } from 'lib/constants';
import { omitBy } from 'lodash';
import { SignInOptions } from './types';

interface Props {
  returnTo?: string;
  errorTo?: string;
  text?: string;
}

/**
 * Use this whenever you need a direct link to Twitch for signin. This handles app-specific
 * logic, requesting a specific username, and specifying a return-to path.
 */
export const onClickTwitchSignIn = (options: SignInOptions) => {
  const baseUrl = '/api/auth/twitch';

  const allParams = {
    next: options.returnTo || '/',
    username: options.username,
    errorTo: options.errorTo,
  };
  const params = omitBy(allParams, (v) => !v) as Record<string, string>;
  const authUrl = `${baseUrl}?${new URLSearchParams(params).toString()}`;

  window.location.href = authUrl;
};

export const TwitchSignIn = ({ returnTo, text, errorTo }: Props) => {
  const onClick = () => onClickTwitchSignIn({
    returnTo,
    errorTo,
  });

  return (
    <button
      type="button"
      className="rounded-lg bg-black hover:bg-opacity-90 font-bold text-white text-xl w-full max-w-xs py-2"
      onClick={onClick}
    >
      <NetworkIcon
        style={{
          color: 'white',
          marginRight: '8px',
          verticalAlign: 'middle',
        }}
        network={NETWORK_IDS.twitch}
      />
      {text || 'Sign in with Twitch'}
    </button>
  );
};
